import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { platformBrowser } from '@angular/platform-browser';

if (environment.production) {
  enableProdMode();
}

platformBrowser()
  .bootstrapModule(AppModule, { 
    applicationProviders: [
      provideZoneChangeDetection(),
      // TinyMCE dialogs cannot appear above CDK overlays placed in the browser top layer.
      { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } }
    ], })
  .catch(err => console.error(err));